import axios from "axios";
import apiurl from "../apiendpoint/apiendpoint";
import { gettoken } from "../../../../shared/services/token/token";

export const apisavePYQ = async (datas) => {
    try {
        const formData = new FormData();
        
        for (const key in datas) {
            if (key === 'Cover_image' && datas[key] instanceof File) {
                formData.append(key, datas[key]);
            } else if (key === 'sections') {
                const sectionsData = JSON.parse(JSON.stringify(datas[key]));
                
                datas[key].forEach((section, sectionIndex) => {
                    section.media_files?.forEach((media, mediaIndex) => {
                        if (media.file instanceof File) {
                            formData.append('section_files', media.file);
                            formData.append('file_mappings', JSON.stringify({
                                sectionIndex,
                                mediaIndex,
                                file_type: media.file_type
                            }));
                            sectionsData[sectionIndex].media_files[mediaIndex].file = null;
                        }
                    });
                });
                
                formData.append(key, JSON.stringify(sectionsData));
            } else {
                formData.append(key, datas[key]);
            }
        }
        
        const token = gettoken();
        const res = await axios.post(`${apiurl()}/pyq/apisavepyqs`, formData, {headers: {"Authorization": `Bearer ${token}`,"Content-Type": "multipart/form-data"}});

        return res.data;
    } catch (err) {
        console.error('API Save PYQ Error:', err.response ? err.response.data : err);
        throw err;
    }
};

export const apiupdatePYQ = async (id, datas) => {
    try {
        const formData = new FormData();
        
        for (const key in datas) {
            if (key === 'Cover_image' && datas[key] instanceof File) {
                formData.append(key, datas[key]);
            } else if (key === 'sections') {
                const sectionsData = JSON.parse(JSON.stringify(datas[key]));
                
                datas[key].forEach((section, sectionIndex) => {
                    section.media_files?.forEach((media, mediaIndex) => {
                        if (media.file instanceof File) {
                            formData.append('section_files', media.file);
                            formData.append('file_mappings', JSON.stringify({
                                sectionIndex,
                                mediaIndex,
                                file_type: media.file_type
                            }));
                            sectionsData[sectionIndex].media_files[mediaIndex].file = null;
                        }
                    });
                });
                
                formData.append(key, JSON.stringify(sectionsData));
            } else {
                formData.append(key, datas[key]);
            }
        }
        
        const token = gettoken();
        const res = await axios.put(`${apiurl()}/pyq/apiupdatepyqs/${id}`, formData, {headers: {"Authorization": `Bearer ${token}`,"Content-Type": "multipart/form-data"}});
        return res.data;
    } catch (err) {
        console.error('API Update PYQ Error:', err.response ? err.response.data : err);
        throw err;
    }
};

export const getadminpyqs = async(params) => {
    const token = gettoken();
    const response = await axios.get(`${apiurl()}/pyq/apigetadminpyqs`,{params:params,headers:{"Authorization" :`Bearer ${token}`}});
    return response.data;
}

 export const getpyqFilterOptions = async(data)=>{
    var res=await axios.post(`${apiurl()}/pyq/getpyqfilteroptions`,{field:data},{headers: {"Authorization" : `Bearer ${gettoken()}`}});
    return res.data;
 }

 export const apideletepyqs = async (id) => {
    try {
        const token = gettoken();
        const res = await axios.delete(`${apiurl()}/pyq/apideletepyqs/${id}`,{headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};